import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withRouter } from 'react-router-dom';

import IconRight from '../../../../images/icons/misc/icon-d-right.svg';

import { PRODUCTS } from '../../../constants';

import Tile from '../../navigation/MobileNavigation/Tile';

import styles from './SlidingProducts.module.scss';

const SlidingProducts = ({
  history,
  products,
  changeProduct,
  expanded,
  setExpanded,
}) => {
  const [exp, setExp] = useState(false);

  const navigate = useCallback(({ url, product: productUpdate }) => {
    setExpanded(false);

    const timer = setTimeout(() => {
      changeProduct(productUpdate);

      history.push(url);
    }, 80);

    return () => {
      clearTimeout(timer);
    };
  }, [changeProduct, history, setExpanded]);

  const productsClassNames = classNames({
    [styles.productsContainer]: true,
    [styles.enter]: expanded
  });
  const spanClassNames = classNames({
    [styles.rightSliderSpan]: true,
    [styles.fadeOut]: expanded,
    [styles.fadeIn]: !expanded
  });
  const iconClassNames = classNames({
    [styles.icon]: true,
    [styles.rotated]: expanded
  });

  const productsTiles = products.map(({
    id,
    name,
    urlName,
    url
  }) => {
    const isPredictions = id === PRODUCTS.predictions;
    const isLinkExternal = url.startsWith('http');
    return (
      <Tile
        key={id}
        product={id}
        name={name}
        iconName={urlName || PRODUCTS.exchange}
        url={url}
        onClick={!isPredictions ? navigate : undefined}
        dataHook={`tablet-nav-${id}`}
        className=".gtm_cta"
        section={'popularProducts'}
        showLabel
        isExternalLink={isLinkExternal}
        openInNewTab={!(isPredictions && isLinkExternal)}
      />
    );
  });

  useEffect(() => {
    if (!expanded) {
      setTimeout(() => {
        setExp(false);
      }, 280);
    } else {
      setExp(true);
    }
  }, [expanded]);

  return (
    <div className={styles.buttonsContainer}>
      <div
        role="button"
        className={styles.rightSliderButton}
        onClick={
          () => {
            setExpanded(!expanded);
          }}
      >
        <IconRight className={iconClassNames} />
      </div>
      {
        <div className={spanClassNames}>
          More from <br /> Matchbook
        </div>
      }
      <div className={productsClassNames}>
        {
          (expanded || (!expanded && exp)) &&
          productsTiles
        }
      </div>
    </div>
  );
};

SlidingProducts.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  changeProduct: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
};

export default withRouter(SlidingProducts);
